/* istanbul ignore file */
export { default } from './VehicleDetail';
